import GeneralSectionComponent from "../generalSectionComponent";
import { KINDS_BOATS_COLUMNS } from "../../../../components/GeneralComponents/SearchTable/TablesColumns";
import { getKindBoat } from "../../../../redux/directoryMaintenance/kindsBoatsReducer/actionKindsBoats";
import KindsBoatsModal from "./kindsBoatsModal/KindsBoatsModal";

function KindsBoats() {
  return (
    <GeneralSectionComponent
      title={"Виды маломерных судов"}
      headerColumns={KINDS_BOATS_COLUMNS}
      dataFromStateSelector={(state) => state.dictionaryReducer.kindsBoats}
      getAction={getKindBoat}
      ModalComponent={KindsBoatsModal}
    />
  );
}

export default KindsBoats;
